import { render } from "./client-rate-history.vue?vue&type=template&id=453dac12&ts=true"
import script from "./client-rate-history.vue?vue&type=script&lang=ts"
export * from "./client-rate-history.vue?vue&type=script&lang=ts"

import "./client-rate-history.vue?vue&type=style&index=0&id=453dac12&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__